import React, { useState } from "react";
import Card from "components/card";
// import Checkbox from "components/checkbox";
import moment from "moment"
import { FiTrash2 } from "react-icons/fi";
import { deleteContactUs } from "api/services/cmsServices";
import { toast } from "react-toastify";
import ConfirmationModal from "components/ConfirmationModal";

export default function ContactUsTable({ tableData, callBack }) {
    const [deleteId, setDeleteId] = useState(null);
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);

    const handleDelete = (id) => {
        setDeleteId(id);
        setIsConfirmOpen(true);
    };

    const confirmDelete = async () => {
        setIsConfirmOpen(false);
        setDeleteId(null);
        let response = await deleteContactUs(deleteId);
        if (response.status === 200) {
            toast.success("Contact us message deleted successfully");
            callBack();
        } else {
            toast.error("Failed to delete contact us message");
        }
    };

    const cancelDelete = () => {
        setIsConfirmOpen(false);
        setDeleteId(null);
    };

    return (
        <Card extra={"w-full h-full sm:overflow-auto px-6 pb-5"}>
            <header className="relative flex flex-col gap-4 pt-4">
                <div className="text-xl font-bold text-navy-700 dark:text-white">
                    Contact us messages
                </div>
            </header>

            {/* Table */}
            <div className="mt-6 overflow-x-scroll xl:overflow-x-hidden">
                <table className="w-full">
                    <thead>
                        <tr className="!border-px !border-gray-400">
                            {["NAME", "EMAIL", "CREATED AT", "MESSAGE", "ACTION"].map((head) => (
                                <th
                                    key={head}
                                    className="cursor-pointer border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start text-sm font-bold text-gray-600 dark:text-white"
                                >
                                    {head}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {tableData?.map((item, index) => (
                            <tr key={index}>
                                <td className="min-w-[150px] py-3 pr-4">
                                    <div className="flex items-center">
                                        {/* <Checkbox defaultChecked={item.name[1]} me="10px" /> */}
                                        <p className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
                                            {item.full_name}
                                        </p>
                                    </div>
                                </td>
                                <td className="min-w-[100px] py-3 pr-4">
                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                        {item.email}
                                    </p>
                                </td>
                                <td className="min-w-[100px] py-3 pr-4">
                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                        {moment(item.createdAt)?.format("DD/MM/YYYY")}
                                    </p>
                                </td>
                                <td className="min-w-[120px] py-3 pr-4">
                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                        {item.message}
                                    </p>
                                </td>
                                <td>
                                    <button
                                        onClick={() => handleDelete(item?._id)}
                                        className="inline-flex items-center justify-center rounded p-1 text-red-500 hover:bg-red-50 dark:hover:bg-white/10"
                                        title="Delete"
                                    >
                                        <FiTrash2 />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <ConfirmationModal
                isOpen={isConfirmOpen}
                onClose={cancelDelete}
                onConfirm={confirmDelete}
                title="Delete FAQ?"
                description="Are you sure you want to delete this FAQ? This action cannot be undone."
                confirmText="Delete"
                cancelText="Cancel"
            />
        </Card>
    );
}
